/**
 * Scenario steps open to the current user (feeds myQuizzesStore). Mount ONCE, in
 * AuthenticatedLayout, next to useMyQuizAssignments. The `visibleTo ==` filter is required:
 * the rules only let a trainee list steps that are open to them.
 */

import { where } from 'firebase/firestore';
import { useFirebaseStore, useFirestoreCollection } from '@/shared';
import { getQuizScenarioStepsCollectionPath } from '@/shared/config';
import type { ScenarioRunStep } from '../types';
import { parseScenarioRunStep } from '../utils/scenarioParse';
import { useMyQuizzesStore } from '../store/myQuizzesStore';

export function useMyScenarioSteps(): void {
  const { db, isConnected, currentUser, visibilityRefreshKey } = useFirebaseStore();
  const email = currentUser?.email?.trim().toLowerCase() ?? null;
  const setSteps = useMyQuizzesStore((s) => s.setSteps);
  const setStepsLoading = useMyQuizzesStore((s) => s.setStepsLoading);
  const setStepsError = useMyQuizzesStore((s) => s.setStepsError);

  useFirestoreCollection<ScenarioRunStep>({
    db,
    collectionPath: email ? getQuizScenarioStepsCollectionPath() : null,
    queryConstraints: email ? [where('visibleTo', '==', email)] : [],
    queryKey: email ?? '',
    parseDocument: parseScenarioRunStep,
    onDataLoaded: setSteps,
    onLoadingChange: setStepsLoading,
    onError: setStepsError,
    enabled: isConnected && !!db && !!email,
    refreshKey: visibilityRefreshKey,
  });
}
